<div class="flex flex-col gap-4 mt-4">
    <div class="flex justify-end gap-2">
        <sag-ui-button
            color="tertiary"
            (click)="clearSnowflakeSearch()"
            [disabled]="isSnowflakeSearchLoading() || !isCoreMlfbSet()"
        >
            {{ 'workflow.snowflake.clear-button' | translate }}
        </sag-ui-button>
        <sag-ui-button
            color="secondary"
            (click)="searchSnowflake()"
            [disabled]="isSnowflakeSearchLoading() || !isCoreMlfbSet()"
        >
            @if (isSnowflakeSearchLoading()) {
                <span class="inline-flex items-center gap-2">
                    <app-loading-indicator></app-loading-indicator>
                    <span>{{ 'general.loading' | translate }}</span>
                </span>
            } @else {
                {{ 'workflow.snowflake.search-button' | translate }}
            }
        </sag-ui-button>
    </div>

    @if (hasSearchedSnowflake()) {
        @if (hasExcessiveSnowflakeResults()) {
            <div
                class="rounded-lg bg-yellow-50 dark:bg-yellow-900/20 border-l-4 border-yellow-500 p-6 mb-4"
                role="alert"
            >
                <div class="flex items-start gap-3">
                    <div class="flex-1">
                        <h3 class="font-bold text-light-textColor dark:text-dark-textColor mb-2">
                            {{ 'workflow.snowflake.excessive-results.title' | translate }}
                        </h3>
                        <p class="text-sm text-light-textColor dark:text-dark-textColor">
                            {{
                                'workflow.snowflake.excessive-results.message'
                                    | translate: { count: snowflakeTotalItems() }
                            }}
                        </p>
                    </div>
                </div>
            </div>
        }
        <sag-ui-table
            [data]="snowflakeResults()"
            [columns]="snowflakeColumns()"
            [config]="snowflakeTableConfig"
            [tableMode]="tableMode"
            [totalItems]="snowflakeTotalItems()"
            [(page)]="currentPage"
            [pageSizeOptions]="pageSizeOptions"
            [(paginationPageSize)]="paginationPageSize"
        ></sag-ui-table>
    } @else {
        <div
            class="rounded-lg border border-light-bgColorSecondary dark:border-dark-bgColorSecondary p-6 text-center text-light-textColorSecondary dark:text-dark-textColorSecondary"
        >
            {{ 'workflow.snowflake.no-search-placeholder' | translate }}
        </div>
    }
</div>
